module.exports = __webpack_public_path__ + "static/media/diagram.0c65d6fd.png";